/** Client-side CSV parse for document table view. Quoted commas + escaped quotes. */

export type ParsedCsv = {
  rows: string[][]
  error: string | null
}

export const CSV_TABLE_ROW_CAP = 10_000

export function parseCsv(text: string): ParsedCsv {
  const source = String(text ?? "")
  const rows: string[][] = []
  let row: string[] = []
  let field = ""
  let inQuotes = false
  let i = 0

  const pushField = () => {
    row.push(field)
    field = ""
  }

  const pushRow = () => {
    pushField()
    rows.push(row)
    row = []
  }

  try {
    while (i < source.length) {
      const ch = source[i]
      if (inQuotes) {
        if (ch === '"') {
          if (source[i + 1] === '"') {
            field += '"'
            i += 2
            continue
          }
          inQuotes = false
          i += 1
          continue
        }
        field += ch
        i += 1
        continue
      }
      if (ch === '"') {
        inQuotes = true
        i += 1
        continue
      }
      if (ch === ",") {
        pushField()
        i += 1
        continue
      }
      if (ch === "\n") {
        pushRow()
        i += 1
        continue
      }
      if (ch === "\r") {
        if (source[i + 1] === "\n") i += 1
        pushRow()
        i += 1
        continue
      }
      field += ch
      i += 1
    }
    if (inQuotes) {
      return { rows: [], error: "Unclosed quoted field" }
    }
    if (field.length > 0 || row.length > 0) {
      pushRow()
    }
    if (rows.length === 1 && rows[0].length === 1 && rows[0][0] === "") {
      return { rows: [], error: null }
    }
    return { rows, error: null }
  } catch (err) {
    return {
      rows: [],
      error: err instanceof Error ? err.message : "Failed to parse CSV",
    }
  }
}
